// Internal dependencies
const {
    generateBackgroundAttributes,
    // generateBorderAttributes,
    generateResBoxControlAttributes,
    generateResRangeAttributes,
    // generateAlignmentAttributes,
    generateTypographyAttributes
    // generateResBtnAttributes
} = window.progressmatifyModules;

// constants
import { IMAX_WIDTH, GL_GAP, G_TYPO, N_TYPO, G_MARGIN, F_BG, B_BG, G_RADIUS, FG_RADIUS } from './constants';

const attributes = {
    label: {
        type: 'string',
        default: 'Progressmatify Bar'
    },
    progressmatify: {
        type: 'number',
        default: 50
    },
    progessbarShow: {
        type: 'boolean',
        default: true
    },
    textColor: {
        type: 'string'
    },
    isVisible: {
        type: 'boolean',
        default: true
    },
    numberColor: {
        type: 'string'
    },

    link: {
        type: 'object',
        default: {
            url: '#',
            openInNewTab: false,
            addNoFollow: false,
            addSponsored: false
        }
    },
    showIcon: {
        type: 'boolean',
        default: false
    },
    sourceType: {
        type: 'string',
        default: 'library'
    },
    icon: {
        type: 'string',
        default: 'arrow-right'
    },
    customIcon: {
        type: 'string'
    },
    iconPos: {
        type: 'string',
        default: 'icon_right'
    },

    // style
    aff_btnSizeType: {
        type: 'string',
        default: 'auto'
    },
    aff_labelColors: {
        type: 'object',
        default: {
            normal: '',
            hover: ''
        }
    },
    aff_iconColors: {
        type: 'object',
        default: {
            normal: '',
            hover: ''
        }
    },
    //glaobal section
    ...generateResRangeAttributes({
        controlName: IMAX_WIDTH
    }),
    ...generateResRangeAttributes({
        controlName: GL_GAP
    }),
    ...generateTypographyAttributes({
        controlName: G_TYPO
    }),
    ...generateTypographyAttributes({
        controlName: N_TYPO
    }),
    ...generateResBoxControlAttributes({
        controlName: G_MARGIN
    }),
    ...generateBackgroundAttributes({
        controlName: F_BG
    }),
    ...generateBackgroundAttributes({
        controlName: B_BG
    }),
    ...generateResBoxControlAttributes({
        controlName: G_RADIUS
    }),
    ...generateResBoxControlAttributes({
        controlName: FG_RADIUS
    })
};

export default attributes;
